/**
 * Public prices as the site lists them: classification is priced per mode (admin's enabled public modes), every
 * other action by its own price.
 */
import type { PublicPricing } from '@borderbot/core/rpc';

export interface PriceRow {
  action: string;
  label: string;
  description: string | null;
  credits: number;
}

export function priceRows(pricing: PublicPricing): PriceRow[] {
  const modes = (pricing.classifyModes ?? []).map((mode) => ({
    action: `classify:${mode.mode}`,
    label: `Classification (${mode.label})`,
    description: mode.description,
    credits: mode.credits,
  }));
  return [...modes, ...pricing.actions];
}

/** What a classification costs in the default mode (else the cheapest), for one-line summaries. */
export function classifyPrice(pricing: PublicPricing | null): { credits: number } | undefined {
  const modes = pricing?.classifyModes ?? [];
  return (
    modes.find((mode) => mode.mode === pricing?.defaultClassifyMode) ??
    [...modes].sort((a, b) => a.credits - b.credits)[0]
  );
}
